import PublicNotesRecord from './record'
import * as PublicNotesSelectors from './selectors'

export const selectors = PublicNotesSelectors
export const record = PublicNotesRecord

export default {
  PublicNotesRecord,
  PublicNotesSelectors,
}
